module.exports = __webpack_public_path__ + "u.no1.5ee5c236.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/u.no1.jpg
// module id = G41n
// module chunks = 0